import MainMenu from '@/components/foundation/main-menu/MainMenu'
import EventDetail from '@/view/event-detail/EventDetail'
import store from '../../state'

export const EventDetailRoute = {
  path: '/event/:id',
  name: 'EventDetail',
  components: {
    default: EventDetail,
    mainMenu: MainMenu
  },
  async beforeEnter (to, from, next) {
    const eventInfo = await store.dispatch('Board/GET_EVENT_DETAILS', {
      eventId: to.params.id
    })
    const eventDetail = { ...eventInfo }
    store.commit('Events/SET_EVENT_INFO', { eventDetail })
    next()
  },
  meta: {
    auth: true,
    mainArea: 'event',
    area: 'event',
    breadcrumb: [
      {
        name: 'Eventos',
        link: '/event'
      },
      {
        eventCode: 'Events/EVENT_CODE',
        isOpenClose: 'Events/IS_OPEN_CLOSE',
        clientName: 'Events/CLIENT_NAME',
        eventIdentification: 'Events/EVENT_IDENTIFICATION',
        linkGetter: 'Events/GET_EVENT_LINK'
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/router/event/EventDetailRoute.js